import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Users, ShieldCheck, CalendarClock, CheckCircle2, Plus } from 'lucide-react';
import { api } from '../api';
import { PageLoading, StatusPill } from '../components/ui';

export default function Dashboard() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get('/dashboard').then(setData).catch(() => setData({})); }, []);
  if (!data) return <PageLoading />;

  const s = data.watchesByStatus || {};
  const totalWatches = Object.values(s).reduce((a, b) => a + b, 0);

  return (
    <>
      <div className="page-head">
        <div><h1>Übersicht</h1><div className="sub">Sicherheitswachen-Einteilung der Feuerwehr</div></div>
        <div className="toolbar"><Link to="/wachen" className="btn btn-primary"><Plus size={16} /> Zu den Wachen</Link></div>
      </div>

      <div className="grid grid-4" style={{ marginBottom: 20 }}>
        <div className="stat"><div className="stat-val">{data.personnel ?? 0}</div><div className="stat-label"><Users size={13} style={{ verticalAlign: -2 }} /> Aktive Dienstleistende</div></div>
        <div className="stat"><div className="stat-val">{totalWatches}</div><div className="stat-label"><ShieldCheck size={13} style={{ verticalAlign: -2 }} /> Wachen gesamt</div></div>
        <div className="stat"><div className="stat-val">{s.assigned || 0}</div><div className="stat-label"><CheckCircle2 size={13} style={{ verticalAlign: -2 }} /> Eingeteilt</div></div>
        <div className="stat"><div className="stat-val">{(s.planned || 0) + (s.draft || 0)}</div><div className="stat-label"><CalendarClock size={13} style={{ verticalAlign: -2 }} /> Offen / geplant</div></div>
      </div>

      <div className="card card-pad">
        <div className="card-title"><CalendarClock size={18} /> Anstehende Wachen</div>
        {(!data.upcoming || data.upcoming.length === 0) ? (
          <div className="empty"><CalendarClock size={40} /><p>Keine anstehenden Wachen.</p></div>
        ) : (
          <div className="table-wrap" style={{ marginTop: 8 }}>
            <table className="table">
              <thead><tr><th>Wache</th><th>Datum</th><th>Status</th><th></th></tr></thead>
              <tbody>
                {data.upcoming.map((w) => (
                  <tr key={w.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/wachen/${w.id}`)}>
                    <td><strong>{w.title}</strong></td>
                    <td>{w.d || '—'}</td>
                    <td><StatusPill status={w.status} /></td>
                    <td className="row-actions" onClick={(e) => e.stopPropagation()}><Link to={`/wachen/${w.id}`} className="btn btn-secondary btn-sm">Öffnen</Link></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
